import { computed, makeObservable, observable } from "mobx"
import { succubus_data_DataLine } from "react-sdk/haxelibs/datamanagertypes.d.ts"
import Chapters from "./Chapters"
import AppState from "./AppState"
import Minigames from "./Minigames/Minigames"
import { Meeting } from "react-sdk/Vertx/MeetingsApi/Meeting"

class AstekActivity {

  /** @type {Meeting} */
  currentMeeting = null

  

  userResults = null

  constructor(currentMeeting) {
    this.currentMeeting = currentMeeting
    this.userResults = { stars : 0, mgResults : {} }
  }


  saveMinigameResult(mgId, result) {
    this.userResults.mgResults[mgId] = result
    let stars = 0
    for (const [id, res] of Object.entries(this.userResults.mgResults))
      stars += res.stars
    this.userResults.stars = stars;
    return this.currentMeeting.customActivityCommand("SetUserMinigameResult", this.currentMeeting.rootActivity.NetID, false, { "group" : AppState.group.groupId, "mgId" : mgId, "result" : result })
  }
  refreshUserResults() {
    return this.currentMeeting.customActivityCommand("GetUserResults", this.currentMeeting.rootActivity.NetID, true).then(results => {
      Object.assign(this.userResults, results)
      for (const [id, res] of Object.entries(this.userResults.mgResults)) {
        let mg = Minigames.get(id)
        if (mg)
          mg.stateFromJson(res)
      }
    })
  }
  clearUserResults(clearGroup = false) {
    this.userResults = { stars : 0, mgResults : {} }
    return this.currentMeeting.customActivityCommand("ClearUserResults", this.currentMeeting.rootActivity.NetID, false, { "group" : AppState.group.groupId, "clearGroup" : clearGroup })
  }

  firstCo() {
    return this.currentMeeting.customActivityCommand("FirstConnection", this.currentMeeting.rootActivity.NetID, false, { "group" : AppState.group.groupId })
  }
}

export default AstekActivity